import styles from "./Terms.module.css";

export const Terms = ({
    termsAndConditionsText,
    standalone,
}: {
    termsAndConditionsText: string;
    standalone?: boolean;
}) => {
    return (
        <section className={standalone ? `${styles.terms} ${styles.standalone}` : styles.terms}>
            <div
                className={styles.content}
                dangerouslySetInnerHTML={{
                    __html: termsAndConditionsText,
                }}
            ></div>
        </section>
    );
};
